<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center">
        <h2 mat-dialog-title>{{title}}</h2>
        <button mat-icon-button (click)="diaglogRef.close('no')" *ngIf="!disableClose">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div [innerHTML]="body"></div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button (click)="submit()">{{submitText}}</button>
        <button mat-raised-button (click)="diaglogRef.close(thirdButtonText)" class="secondary" *ngIf="!isThridButtonDisabled && thirdButtonText">{{thirdButtonText}}</button>
        <button mat-raised-button (click)="diaglogRef.close(otherText)" class="warning" *ngIf="!isOtherTextDisabled">{{otherText}}</button>
    </mat-dialog-actions>
</div>